// extracted by mini-css-extract-plugin
export default {"select":"template_selector-module___select___ad95d1b3","dropdownValue":"template_selector-module___dropdownValue___fbccaeca"};